import styles from "./ALumniPaymentSuccess.module.css";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Loader from "@/components/Loader/Loader";
import Image from "next/image";

const ALumniPaymentSuccess = () => {
  const router = useRouter();
  const [showLoader, setShowLoader] = useState(true);
  const [donationDetails, setDonationDetails] = useState<{
    amount: number;
    email: string;
    name: string;
    reference: any;
  } | null>(null);

  // Get status from query and ensure it's a string
  const queryStatus = router.query.status;
  const status = Array.isArray(queryStatus)
    ? queryStatus[0]
    : queryStatus || "";

  // Load donation details from localStorage
  useEffect(() => {
    const storedDetails = localStorage.getItem("donationDetails");
    if (storedDetails) {
      setDonationDetails(JSON.parse(storedDetails));
    }
  }, []);

  // Handle loader timeout
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!status) return;

    const currentPath = router.asPath;

    if (status === "SUCCESSFUL" && !currentPath.includes("payment-success")) {
      router.push(`/payment-success?status=${status}`);
    } else if (
      (status === "PENDING" || status === "TIMEOUT") &&
      !currentPath.includes("payment-failure")
    ) {
      router.push(`/payment-failure?status=${status}`);
    } else if (
      ["ERROR_PERM", "CANCEL", "CANCELLED"].includes(status) &&
      !currentPath.includes("payment-error")
    ) {
      router.push(`/payment-error?status=${status}`);
    } else if (
      ![
        "SUCCESSFUL",
        "PENDING",
        "TIMEOUT",
        "ERROR_PERM",
        "CANCEL",
        "CANCELLED",
      ].includes(status) &&
      !currentPath.includes("payment-error")
    ) {
      // Unknown status - redirect to error page
      router.push(`/payment-error?status=${status}`);
    }
  }, [status, router]);

  if (showLoader) {
    return <Loader />;
  }

  return (
    <div className={styles.PaymentSuccessPage}>
      <div className={styles.container}>
        <div className={styles.card}>
          <div className={styles.iconWrapper}>
            <span className={styles.checkIcon}>
              <Image
                src="/assets/success.png"
                alt="alumni-payment-success-icon"
                title="alumni-payment-success-icon"
                className={styles.logo}
                width={64}
                height={64}
              />
            </span>
          </div>
          <h1 className={styles.title}>Donation Successful!</h1>
          <p className={styles.subtitle}>
            You're Now Part of Someone's Success Story
          </p>
          <div className={styles.amountTag}>
            AMOUNT DONATED: R {donationDetails?.amount}
          </div>

          <button
            className={styles.homeButton}
            onClick={() => router.push("/")}
          >
            Go to Homepage
          </button>
        </div>
      </div>
    </div>
  );
};

export default ALumniPaymentSuccess;
